const menu = {
    state: {
        menu:[
            {
                type:'mail',
                name:'首页',
                // child:['词库管理','文章管理','启动页管理','作文题目发放','优秀作文展示',]
            },
            {
                type:'mail',
                name:'内容管理',
                child:['词库管理','文章管理','启动页管理','作文题目发放','优秀作文展示',]
            },
            {
                type:'mail',
                name:'成绩查询',
                child:[
                    '单词成绩',
                    '文章成绩',
                   
                ]
            },
            {
                type:'mail',
                name:'学生管理',
                child:[
                    '学生信息查看',    
                ]
            },
            {
                type:'mail',
                name:'全局设置',
                child: [
                    '游戏价格设置',    
                ]
            }
        ]
    }
}
export default menu